export enum DemoEntryRoutingId {
    RouterService = "DEMO_ROUTING_ID",
    DemoGallery = "DEMO_GALLERY",
    Demo = "DEMO",
}
